import { gql } from '@apollo/client'
import { ARTICLE_ITEM_FIELDS } from './fragments'

/** 资讯列表 */
export const GET_ARTICLE_LIST = gql`
  ${ARTICLE_ITEM_FIELDS}
  query getArticleList($first: Int, $offset: Int) {
    articleGraph {
      articleList: listArticle(page: { first: $first, offset: $offset }) {
        edges {
          node {
            ...articleItemFields
          }
        }
        pageInfo {
          totalCount
          hasNextPage
        }
      }
    }
  }
`

/** 资讯详情：已发布 */
export const GET_ARTICLE_DETAIL = gql`
  ${ARTICLE_ITEM_FIELDS}
  query getArticleDetail($postId: Int!) {
    articleGraph {
      detail: publishedArticleById(postId: $postId) {
        ...articleItemFields
        post {
          postUrl
          # 正文
          content
        }
        extra {
          copyrightInfo {
            originalName
          }
        }
      }
    }
  }
`

/** 资讯详情：预览 */
export const GET_ARTICLE_PREVIEW_DETAIL = gql`
  ${ARTICLE_ITEM_FIELDS}
  query getArticlePreviewDetail($key: String!) {
    articleGraph {
      detail: articleByKey(key: $key) {
        ...articleItemFields
        post {
          postUrl
          # 正文
          content
        }
        extra {
          copyrightInfo {
            originalName
          }
        }
      }
    }
  }
`
